module.exports = __webpack_public_path__ + "static/media/Beldum_gaussian2.36a2cd75.png";